
import ProductFormHandler from '../qf/productFormHandler.js';

document.addEventListener("DOMContentLoaded", () => {
  // Find product gallery lightbox triggers
  let pageHasRecomendations = document.querySelector(".product-recommendations") || false;
  let timeout = pageHasRecomendations ? 2000 : 0;
  const ligthbox_data_atts = document.querySelectorAll(".main-product .main-gallery [data-fslightbox]");

  setTimeout(async function () {
    let quickViewModal = document.querySelector(".quick-view-container");

    if (quickViewModal) {
      let quickViewModalInner = quickViewModal.querySelector(".inner");
      let quickViewControls = document.querySelectorAll("[open-quick-view]");
      let quickViewClose = quickViewModal.querySelector(".close");

      let sectionName = "fg-main-product";

      document.addEventListener('click', async (e) => {
        let target = e.target;
        if (target.getAttribute('open-quick-view') != null) {
          // Close side cart if button is in cart recommendations or cart drawer
          const isInCartDrawer = target.closest('#cart-drawer-container') !== null;
          const isCartRecommended = target.getAttribute("data-cart-recommended") != null;
          if (isCartRecommended || isInCartDrawer) {
            window.cart.closeSideCart();
          }
          let control = target;
          let handle = control.getAttribute("data-product-handle");

          if (handle) {
            if (ligthbox_data_atts.length > 1) {
              ligthbox_data_atts.forEach((lightbox_data_att) => {
                // Remove the data-fslightbox attribute to prevent the lightbox from opening
                lightbox_data_att.removeAttribute("data-fslightbox");
              });
            }

            let sku = control.getAttribute("data-sku");
            let in_stock = control.getAttribute("data-stock");
            let price = control.getAttribute("data-price");
            e.preventDefault();
            try {
              const response = await fetch(`/products/${handle}?sections=${sectionName}`);
              if (response.ok) {
                const sectionData = await response.json();
                const sectionHtml = sectionData[`${sectionName}`];

                if (quickViewModalInner && sectionHtml) {
                  quickViewModalInner.innerHTML = sectionHtml;

                  // Load any scripts in the section
                  const scriptTags = quickViewModalInner.querySelectorAll('script');
                  for (const scriptTag of scriptTags) {
                    if (scriptTag.src) {
                      const scriptElement = document.createElement('script');
                      scriptElement.src = scriptTag.src;
                      scriptElement.async = scriptTag.async || false;
                      document.body.appendChild(scriptElement);
                    } else {
                      try {
                        eval(scriptTag.textContent);
                      } catch (error) {
                        console.error('Error executing script:', error);
                      }
                    }
                  }

                  // Add lightbox data attribute to the product gallery
                  const ligthboxDataAtts = quickViewModalInner.querySelectorAll(".lightbox-trigger");
                  if (ligthboxDataAtts.length > 1) {
                    for (const ligthboxDataAtt of ligthboxDataAtts) {
                      ligthboxDataAtt.setAttribute("data-fslightbox","");
                    }
                  }
                  refreshFsLightbox();

                  // Initialize Trustpilot widgets if present
                  const trustpilotWidgetDesktop = quickViewModal.querySelector('.product-reviews-desktop .trustpilot-widget');
                  if (trustpilotWidgetDesktop && window.Trustpilot) {
                    window.Trustpilot.loadFromElement(trustpilotWidgetDesktop);
                  }

                  const trustpilotWidgetMobile = quickViewModal.querySelector('.product-reviews-mobile .trustpilot-widget');
                  if (trustpilotWidgetMobile && window.Trustpilot) {
                    window.Trustpilot.loadFromElement(trustpilotWidgetMobile);
                  }

                  // Init sliders
                  initQuickViewSliders(quickViewModalInner);

                  // Initialize the ProductFormHandler for the quick view modal
                  try {
                    console.log('Initializing ProductFormHandler for quick view');

                    // Find the specific product form element in the quick view
                    const quickViewForm = quickViewModalInner.querySelector('.product-form');

                    if (quickViewForm) {
                      console.log('Found product form in quick view:', quickViewForm);
                      const quickViewProductForm = new ProductFormHandler(quickViewForm);
                      console.log('ProductFormHandler initialized successfully for quick view');

                      // Store a reference to the handler on the modal element for debugging
                      quickViewModal._productFormHandler = quickViewProductForm;
                    } else {
                      console.error('Could not find product form in quick view');
                    }
                  } catch (err) {
                    console.error('Error initializing ProductFormHandler:', err);
                  }

                  // Check if subscription intent was set and auto-select subscription radio
                  // This happens after ProductFormHandler initialization to ensure proper state
                  const hasSubscriptionIntent = control.getAttribute('data-subscription-intent') === 'true';
                  if (hasSubscriptionIntent) {
                    // Wait for ProductFormHandler to complete initialization
                    setTimeout(() => {
                      const subscriptionRadio = quickViewModalInner.querySelector('[data-subscription-radio]');
                      const onetimeRadio = quickViewModalInner.querySelector('[data-onetime-radio]');
                      
                      if (subscriptionRadio && onetimeRadio) {
                        subscriptionRadio.checked = true;
                        onetimeRadio.checked = false;
                        
                        // Trigger change event to update UI
                        subscriptionRadio.dispatchEvent(new Event('change', { bubbles: true }));
                        console.log('Subscription radio auto-selected');
                      } else {
                        console.error('Could not find subscription radios');
                      }
                    }, 200);
                  }

                  // Form submission handling (keep this as the ProductFormHandler doesn't handle form submission)
                  setupFormSubmissionHandler(quickViewModalInner, quickViewModal);

                  // add listener for read more
                  initReadMore(quickViewModalInner);

                  // Show quick view modal
                  quickViewModal.classList.add("active");
                  document.body.style.overflow = "hidden";

                  // Dispatch event for analytics
                  window.dispatchEvent(new CustomEvent('quickview_opened', {
                    detail: {
                      item_id: sku,
                      in_stock: in_stock,
                      price: price
                    }
                  }));
                }
              } else {
                throw new Error('Error: ' + response.status);
              }
            } catch (error) {
              console.error(error);
            }
          }
        }
      });

      // Close button event
      quickViewClose.addEventListener("click", () => {
        closeQuickViewModal(quickViewModal);
      });

      // Close on click outside
      document.addEventListener("click", (e) => {
        if (e.target === quickViewModal) {
          closeQuickViewModal(quickViewModal);
        }
      });
    }
  }, timeout);
});

// Helper functions to keep the code organized

function initQuickViewSliders(quickViewModalInner) {
  // Init gallery thumbs swiper
  let gallery_thumbs_swiper = new window.swiper(".inner .thumb-swiper", {
    spaceBetween: 15,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
      992: {
        slidesPerView: 4,
        direction: "vertical",
      },
    },
  });

  // Init main gallery swiper
  let gallery_swiper = new window.swiper(".inner .main-swiper", {
    spaceBetween: 20,
    navigation: {
      nextEl: ".inner .swiper-button-next",
      prevEl: ".inner .swiper-button-prev",
    },
    thumbs: {
      swiper: gallery_thumbs_swiper,
    },
    on: {
      init: function () {
        let check_width = setInterval(() => {
          setThumbHeight();
        }, 200);

        function setThumbHeight() {
          let main_swiper_slide = document.querySelector('.inner .main-swiper-slide');
          let thumb_swiper_slide = document.querySelector('.inner .swiper-slide.thumb');
          let thumb_swiper = document.querySelector('.inner .thumb-swiper');

          if (!main_swiper_slide || !thumb_swiper) return;

          let main_swiper_width = main_swiper_slide.offsetWidth;

          main_swiper_slide.style.height = main_swiper_width + 'px';

          if (main_swiper_width > 0) {
            clearInterval(check_width);

            thumb_swiper.style.cssText = "position: relative;opacity:1";

            if (window.innerWidth > 991.98) {
              thumb_swiper.style.height = main_swiper_width + 'px';
            }
          }
        }

        const galleryContainer = document.querySelector('.inner .gallery-container');
        if (galleryContainer) {
          galleryContainer.style.opacity = 1;
        }

        window.addEventListener('resize', () => {
          let main_swiper_slide = document.querySelector('.inner .main-swiper');
          let thumb_swiper_slide = document.querySelector('.inner .swiper-slide.thumb');
          let thumb_swiper = document.querySelector('.inner .thumb-swiper');

          if (!main_swiper_slide || !thumb_swiper) return;

          let main_swiper_width = main_swiper_slide.offsetWidth;

          main_swiper_slide.style.height = main_swiper_width + 'px';

          if (window.innerWidth > 991.98) {
            thumb_swiper.style.height = main_swiper_width + 'px';
          }
        });
      },
    },
  });
}

function setupFormSubmissionHandler(quickViewModalInner, quickViewModal) {
  const productForm = quickViewModalInner.querySelector('[action="/cart/add"]');

  if (productForm) {
    productForm.addEventListener("submit", function (e) {
      e.preventDefault();

      // Get the quantity from the quantity input
      let quantity = productForm.querySelector(".quantity-input").value;

      // Get the selected variant ID - using the currently selected radio if available
      let id;
      const selectedVariantRadio = productForm.querySelector('.variant-size-radio:checked');
      if (selectedVariantRadio) {
        id = selectedVariantRadio.value;
      } else {
        id = productForm.querySelector("#product-id").value;
      }

      // Check for selling plan (subscription option)
      const purchaseTypeRadios = productForm.querySelectorAll('.purchase-type-radio');
      const isSubscription = purchaseTypeRadios.length > 0 &&
                            Array.from(purchaseTypeRadios).some(radio =>
                              radio.checked && radio.value === 'subscription');

      // Get the selling plan ID if subscription is selected
      const sellingPlanSelect = productForm.querySelector("#selling_plan_select");
      let sellingPlanId = null;

      if (isSubscription && sellingPlanSelect && !sellingPlanSelect.disabled) {
        sellingPlanId = sellingPlanSelect.value;

        if (quantity && id && sellingPlanId) {
          // detect compare_at_price from selected variant radio or visible price UI
          let compareAt = null;
          if (selectedVariantRadio && selectedVariantRadio.dataset && selectedVariantRadio.dataset.variantComparePrice) {
            const val = parseFloat(selectedVariantRadio.dataset.variantComparePrice);
            if (!isNaN(val)) compareAt = val.toFixed(2) / 100;
          }
          if (!compareAt && selectedVariantRadio) {
            const variantId = selectedVariantRadio.value;
            const wasPriceEl = productForm.querySelector(`#subscription-price-display .variant-price-container[data-variant-id="${variantId}"] .was-price`);
            if (wasPriceEl && wasPriceEl.textContent) {
              const parsed = parseFloat(wasPriceEl.textContent.replace(/[^0-9.-]+/g, ''));
              if (!isNaN(parsed)) compareAt = parsed.toFixed(2) / 100;
            }
          }

          const props = { "_selling_plan": sellingPlanId };
          if (compareAt) props._compare_at_price = compareAt;

          window.cart.add({ items: [{ id, quantity, selling_plan: sellingPlanId, properties: props }] });
          quickViewModal.classList.remove("active");
          document.body.style.overflow = "auto";
        }
      } else {
        if (quantity && id) {
          // detect compare_at_price from selected variant radio or visible price UI
          let compareAt = null;
          if (selectedVariantRadio && selectedVariantRadio.dataset && selectedVariantRadio.dataset.variantComparePrice) {
            const val = parseFloat(selectedVariantRadio.dataset.variantComparePrice);
            if (!isNaN(val)) compareAt = val.toFixed(2) / 100;
          }
          if (!compareAt && selectedVariantRadio) {
            const variantId = selectedVariantRadio.value;
            const wasPriceEl = productForm.querySelector(`#one-time-price-display .variant-price-container[data-variant-id="${variantId}"] .was-price`);
            if (wasPriceEl && wasPriceEl.textContent) {
              const parsed = parseFloat(wasPriceEl.textContent.replace(/[^0-9.-]+/g, ''));
              if (!isNaN(parsed)) compareAt = parsed.toFixed(2) / 100;
            }
          }
          const item = { id, quantity };
          if (compareAt) item.properties = { "_compare_at_price": compareAt };
          window.cart.add({ items: [item] });
          quickViewModal.classList.remove("active");
          document.body.style.overflow = "auto";
        }
      }
    });
  }
}

function initReadMore(quickViewModalInner) {
  let read_more = quickViewModalInner.querySelector(".product-description-container[read-more-qf]");

  if (read_more) {
    let read_more_control = read_more.querySelector(".read-more");
    let excerpt = read_more.querySelector("span.excerpt");
    let full = read_more.querySelector("span.full");

    read_more_control.addEventListener("click", () => {
      if (read_more.classList.contains("active")) {
        read_more.classList.remove("active");
        read_more_control.innerHTML = "Read more";
      } else {
        read_more.classList.add("active");
        read_more_control.innerHTML = "Read less";
      }
    });
  }
}

function closeQuickViewModal(quickViewModal) {
  quickViewModal.classList.remove("active");
  document.body.style.overflow = "auto";

  // Restore lightbox functionality on the main product gallery
  const ligthbox_data_atts = document.querySelectorAll(".main-product .main-gallery .lightbox-trigger");
  if (ligthbox_data_atts.length > 1) {
    ligthbox_data_atts.forEach((lightbox_data_att) => {
      // Add the data-fslightbox attribute to so the product gallery lightbox can open
      lightbox_data_att.setAttribute("data-fslightbox","");
    });

    const qv_lightbox_data_atts = quickViewModal.querySelectorAll(".lightbox-trigger");
    if (qv_lightbox_data_atts.length > 1) {
      qv_lightbox_data_atts.forEach((qv_lightbox_data_att) => {
        // Remove the data-fslightbox attribute to prevent the lightbox from opening
        qv_lightbox_data_att.removeAttribute("data-fslightbox");
      });
    }

    // Refresh lightbox
    if (typeof refreshFsLightbox === 'function') {
      refreshFsLightbox();
    }
  }
}